import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "../../stores/store";
import { useEffect } from "react";
import { fetchTopics } from "../../stores/slices/topicSlice";


const Topic = () => {
  const topicData = useSelector((state: RootState) => state.topics.topics);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchTopics());
  }, [dispatch]);

  const toEdit = (id: number) => {
    navigate(`/topic/edit/${id}`);
  }

  return (
    <>
      <h2>トピクス一覧</h2>
      <div className="submit big">
        <Link to={"/topic/new"}>新規登録</Link>
      </div>

      <div className="tableDataList">
        <table>
          <tbody>
            <tr>
              <th>ID</th>
              <th>タイトル</th>
              <th>本文</th>
              <th>リンク先</th>
              <th>登録日</th>
              <th>更新日</th>
              <th style={{minWidth: '80px'}}>ステータス</th>
            </tr>

            {topicData.map((topic : any) => (
              <tr onClick={() => toEdit(topic.id)} style={{ cursor: 'pointer'}} key={topic.id}>
                <td>
                  {topic.id}
                </td>
                <td>
                  {topic.title}
                </td>
                <td>
                  {topic.body}
                </td>
                <td>
                  {topic.link}
                </td>
                <td>
                  {topic.created_at}
                </td>
                <td>
                  {topic.updated_at}
                </td>
                <td>
                  {topic.status === 0 ? ( 
                    <span>公開</span>
                  ):(
                    <span>非公開</span>
                  )}
                </td>
                <td>
                  <div className="submit">
                    <Link to={`/topic/edit/${topic.id}`}>登録</Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default Topic;